import { create } from "zustand";

export type TopbarMetricKey = "downloads" | "ai" | "rewards" | "fidelity";

type TopbarHighlightState = {
  metric: TopbarMetricKey | null;
  setMetric: (metric: TopbarMetricKey | null) => void;
};

// Compteur de la barre du haut mis en évidence par une fenêtre de notification.
export const useTopbarHighlight = create<TopbarHighlightState>((set) => ({
  metric: null,
  setMetric: (metric) => set({ metric }),
}));
